export const dgList = [
    [
        { "idgame": "1003" },
        { "idgame": "1009" },
        { "idgame": "1001" },
        { "idgame": "1004" },
        { "idgame": "1002" },
        { "idgame": "1007" },
        { "idgame": "1008" },
        { "idgame": "1006" },
        { "idgame": "1012" },
        { "idgame": "1010" },
        { "idgame": "1011" },
        { "idgame": "1005" },
        { "idgame": "3073" },
        { "idgame": "3067" },
        { "idgame": "3043" },
        { "idgame": "3084" },
        { "idgame": "3088" },
        { "idgame": "3003" },
        { "idgame": "3075" },
        { "idgame": "3034" },
        { "idgame": "3037" },
        { "idgame": "3031" },
        { "idgame": "3601" },
        { "idgame": "3064" },
        { "idgame": "3082" },
        { "idgame": "3027" },
        { "idgame": "3019" },
        { "idgame": "3020" },
        { "idgame": "3042" },
        { "idgame": "3038" },
        { "idgame": "3036" },
        { "idgame": "3030" },
        { "idgame": "3025" },
        { "idgame": "3033" },
        { "idgame": "3007" },
        { "idgame": "3009" },
        { "idgame": "3060" },
        { "idgame": "3001" },
        { "idgame": "3044" },
        { "idgame": "3040" },
        { "idgame": "3029" },
        { "idgame": "3079" },
        { "idgame": "3015" },
        { "idgame": "3063" },
        { "idgame": "3046" },
        { "idgame": "3004" },
        { "idgame": "3061" },
        { "idgame": "3076" },
        { "idgame": "3039" },
        { "idgame": "3014" },
        { "idgame": "3035" },
        { "idgame": "3022" },
        { "idgame": "3070" },
        { "idgame": "3024" },
        { "idgame": "3078" },
        { "idgame": "3005" },
        { "idgame": "3010" },
        { "idgame": "3021" },
        { "idgame": "3065" },
        { "idgame": "3012" },
        { "idgame": "3013" },
        { "idgame": "3026" },
        { "idgame": "3008" },
        { "idgame": "3028" },
        { "idgame": "3011" },
        { "idgame": "3016" },
        { "idgame": "3045" },
        { "idgame": "3081" },
        { "idgame": "3072" },
        { "idgame": "3071" },
        { "idgame": "3055" },
        { "idgame": "3032" },
        { "idgame": "3066" },
        { "idgame": "3017" },
        { "idgame": "3052" },
        { "idgame": "3069" },
        { "idgame": "3057" },
        { "idgame": "3062" },
        { "idgame": "3048" },
        { "idgame": "3018" },
        { "idgame": "3080" },
        { "idgame": "3051" },
        { "idgame": "3023" },
        { "idgame": "3006" },
        { "idgame": "3041" },
        { "idgame": "3047" },
        { "idgame": "3059" },
        { "idgame": "3068" },
        { "idgame": "3053" },
        { "idgame": "3054" },
        { "idgame": "3049" },
        { "idgame": "3074" },
        { "idgame": "3050" },
        { "idgame": "3077" },
        { "idgame": "3056" },
        { "idgame": "4006" },
        { "idgame": "4013" },
        { "idgame": "4014" },
        { "idgame": "4009" },
        { "idgame": "4002" },
        { "idgame": "4016" },
        { "idgame": "4011" },
        { "idgame": "4004" },
        { "idgame": "4007" },
        { "idgame": "4010" },
        { "idgame": "4003" },
        { "idgame": "4001" },
        { "idgame": "4008" },
        { "idgame": "4005" }
    ]

]